// Цена предмета магазина по тиру, души. Как `TIER_COST` в бэкенде (analysis.detectors).
export const TIER_COST: Readonly<Record<number, number>> = {
  1: 800,
  2: 1600,
  3: 3200,
  4: 6400,
};
